import { render, staticRenderFns } from "./wageTop.vue?vue&type=template&id=a8b8da90&scoped=true&"
import script from "./wageTop.vue?vue&type=script&lang=js&"
export * from "./wageTop.vue?vue&type=script&lang=js&"
import style0 from "./wageTop.vue?vue&type=style&index=0&id=a8b8da90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b8da90",
  null
  
)

export default component.exports